export default __webpack_public_path__ + "dist/media/View.6f90986c.svg";